import { trigger, state, style, transition, animate, AnimationPlayer, AnimationBuilder, AnimationMetadata } from '@angular/animations';
import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SubmenuDisplayHandlerService } from './submenu-display-handler.service';

@Directive({
  selector: '[kvCollapseSubmenu]',
  
  /* animations: [
    trigger('collapse', [
      state('0', style({ height: '0', opacity: '0' })),
      state('1', style({ height: '*', opacity: '1' })),
      transition('0 <=> 1', animate('{{duration}}ms {{easing}}'), {
      params: {
        duration: 500,
        easing: "ease-in-out"
      }
    })
    ])
  ] */
})
export class CollapseSubmenuDirective implements OnChanges{
  player: AnimationPlayer;
  //metadata:
  showSubmenu$ = this.submenuDisplayHandlerService.getShowSubMenu().pipe().subscribe((showSubmenu) => {
    if (this.player) {
      this.player.destroy();
    }

    const metadata = showSubmenu ? this.fadeIn() : this.fadeOut();

    const factory = this.builder.build(metadata);
    const player = factory.create(this.el.nativeElement);

    player.play();
  })
  //@Input()
  /* set showSubmenu(showSubmenu: boolean) {
    if (this.player) {
      this.player.destroy();
    }

    const metadata = showSubmenu ? this.fadeIn() : this.fadeOut();

    const factory = this.builder.build(metadata);
    const player = factory.create(this.el.nativeElement);

    player.play();
  } */
  constructor(
    private builder: AnimationBuilder, 
    private el: ElementRef,
    private submenuDisplayHandlerService:SubmenuDisplayHandlerService) { }
  
    private fadeIn(): AnimationMetadata[] {
    return [
      style({ opacity: 0 }),
      animate('400ms ease-in', style({ opacity: 1 })),
    ];
  }

  private fadeOut(): AnimationMetadata[] {
    return [
      style({ opacity: '*' }),
      animate('400ms ease-in', style({ opacity: 0 })),
    ];
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    /* if(changes["showSubmenu"]){
      console.log(this.showSubmenu);
    } */
  }
}
